import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHousesWithCamera = async (companyId) => {
  return await request.get(
    `/Camera/houses`,
    { companyId },
    'При загрузке списка домов с камерами наблюдения произошла ошибка',
    []
  );
};

const useHousesWithCamera = (companyId, options) => {
  const id = typeof companyId === 'string' ? Number(companyId) : companyId;

  return useQuery(
    getQueryKeys.housesWithCamera(id),
    () => getHousesWithCamera(id),
    options
  );
};

export default useHousesWithCamera;
